export const FETCH_KEYWORDS_REQUEST = 'pvs/FETCH_KEYWORDS_REQUEST';
export const FETCH_KEYWORDS_SUCCESS = 'pvs/FETCH_KEYWORDS_SUCCESS';
export const FETCH_KEYWORDS_FAILURE = 'pvs/FETCH_KEYWORDS_FAILURE';
export const FETCH_KEYWORDS_RESET = 'pvs/FETCH_KEYWORDS_RESET';

export const UPDATE_PVS_REGISTRATION_REQUEST = 'pvs/UPDATE_PVS_REGISTRATION_REQUEST';
export const UPDATE_PVS_REGISTRATION_SUCCESS = 'pvs/UPDATE_PVS_REGISTRATION_SUCCESS';
export const UPDATE_PVS_REGISTRATION_FAILURE = 'pvs/UPDATE_PVS_REGISTRATION_FAILURE';
export const UPDATE_PVS_REGISTRATION_RESET = 'pvs/UPDATE_PVS_REGISTRATION_RESET';

export const VERIFY_PVS_REGISTRATION_PAYMENT_REQUEST = 'pvs/VERIFY_PVS_REGISTRATION_PAYMENT_REQUEST';
export const VERIFY_PVS_REGISTRATION_PAYMENT_SUCCESS = 'pvs/VERIFY_PVS_REGISTRATION_PAYMENT_SUCCESS';
export const VERIFY_PVS_REGISTRATION_PAYMENT_FAILURE = 'pvs/VERIFY_PVS_REGISTRATION_PAYMENT_FAILURE';
export const VERIFY_PVS_REGISTRATION_PAYMENT_RESET = 'pvs/VERIFY_PVS_REGISTRATION_PAYMENT_RESET';

export const FETCH_PVS_REQUEST = 'pvs/FETCH_PVS_REQUEST';
export const FETCH_PVS_SUCCESS = 'pvs/FETCH_PVS_SUCCESS';
export const FETCH_PVS_FAILURE = 'pvs/FETCH_PVS_FAILURE';

export const CREATE_PVS_REQUEST = 'pvs/CREATE_PVS_REQUEST';
export const CREATE_PVS_SUCCESS = 'pvs/CREATE_PVS_SUCCESS';
export const CREATE_PVS_FAILURE = 'pvs/CREATE_PVS_FAILURE';

export const UPDATE_PVS_REQUEST = 'pvs/UPDATE_PVS_REQUEST';
export const UPDATE_PVS_SUCCESS = 'pvs/UPDATE_PVS_SUCCESS';
export const UPDATE_PVS_FAILURE = 'pvs/UPDATE_PVS_FAILURE';
export const RESET_UPDATE_PVS_STATE = 'pvs/RESET_UPDATE_PVS_STATE';

export const DELETE_PVS_REQUEST = 'pvs/DELETE_PVS_REQUEST';
export const DELETE_PVS_SUCCESS = 'pvs/DELETE_PVS_SUCCESS';
export const DELETE_PVS_FAILURE = 'pvs/DELETE_PVS_FAILURE';

export const FETCH_PVS_CATEGORY_REQUEST = 'pvs/FETCH_PVS_CATEGORY_REQUEST';
export const FETCH_PVS_CATEGORY_SUCCESS = 'pvs/FETCH_PVS_CATEGORY_SUCCESS';
export const FETCH_PVS_CATEGORY_FAILURE = 'pvs/FETCH_PVS_CATEGORY_FAILURE';

export const CREATE_PVS_CATEGORY_REQUEST = 'pvs/CREATE_PVS_CATEGORY_REQUEST';
export const CREATE_PVS_CATEGORY_SUCCESS = 'pvs/CREATE_PVS_CATEGORY_SUCCESS';
export const CREATE_PVS_CATEGORY_FAILURE = 'pvs/CREATE_PVS_CATEGORY_FAILURE';
export const RESET_PVS_CATEGORY_STATE = 'pvs/RESET_PVS_CATEGORY_STATE';


export const UPDATE_PVS_CATEGORY_REQUEST = 'pvs/UPDATE_PVS_CATEGORY_REQUEST';
export const UPDATE_PVS_CATEGORY_SUCCESS = 'pvs/UPDATE_PVS_CATEGORY_SUCCESS';
export const UPDATE_PVS_CATEGORY_FAILURE = 'pvs/UPDATE_PVS_CATEGORY_FAILURE';

export const FETCH_PVS_CATEGORY_DETAILS_REQUEST = 'pvs/FETCH_PVS_CATEGORY_DETAILS_REQUEST';
export const FETCH_PVS_CATEGORY_DETAILS_SUCCESS = 'pvs/FETCH_PVS_CATEGORY_DETAILS_SUCCESS';
export const FETCH_PVS_CATEGORY_DETAILS_FAILURE = 'pvs/FETCH_PVS_CATEGORY_DETAILS_FAILURE';

export const FETCH_PVS_SUBCATEGORY_REQUEST = 'pvs/FETCH_PVS_SUBCATEGORY_REQUEST';
export const FETCH_PVS_SUBCATEGORY_SUCCESS = 'pvs/FETCH_PVS_SUBCATEGORY_SUCCESS';
export const FETCH_PVS_SUBCATEGORY_FAILURE = 'pvs/FETCH_PVS_SUBCATEGORY_FAILURE';
export const RESET_PVS_SUBCATEGORY_STATE = 'pvs/RESET_PVS_SUBCATEGORY_STATE';

export const CREATE_PVS_SUBCATEGORY_REQUEST = 'pvs/CREATE_PVS_SUBCATEGORY_REQUEST';
export const CREATE_PVS_SUBCATEGORY_SUCCESS = 'pvs/CREATE_PVS_SUBCATEGORY_SUCCESS';
export const CREATE_PVS_SUBCATEGORY_FAILURE = 'pvs/CREATE_PVS_SUBCATEGORY_FAILURE';

export const UPDATE_PVS_SUBCATEGORY_REQUEST = 'pvs/UPDATE_PVS_SUBCATEGORY_REQUEST';
export const UPDATE_PVS_SUBCATEGORY_SUCCESS = 'pvs/UPDATE_PVS_SUBCATEGORY_SUCCESS';
export const UPDATE_PVS_SUBCATEGORY_FAILURE = 'pvs/UPDATE_PVS_SUBCATEGORY_FAILURE';

export const FETCH_PVS_SUBCATEGORY_DETAILS_REQUEST = 'pvs/FETCH_PVS_SUBCATEGORY_DETAILS_REQUEST';
export const FETCH_PVS_SUBCATEGORY_DETAILS_SUCCESS = 'pvs/FETCH_PVS_SUBCATEGORY_DETAILS_SUCCESS';
export const FETCH_PVS_SUBCATEGORY_DETAILS_FAILURE = 'pvs/FETCH_PVS_SUBCATEGORY_DETAILS_FAILURE';

export const FETCH_PVS_KEYWORD_REQUEST = 'pvs/FETCH_PVS_KEYWORD_REQUEST';
export const FETCH_PVS_KEYWORD_SUCCESS = 'pvs/FETCH_PVS_KEYWORD_SUCCESS';
export const FETCH_PVS_KEYWORD_FAILURE = 'pvs/FETCH_PVS_KEYWORD_FAILURE';
export const RESET_PVS_KEYWORD_STATE = 'pvs/RESET_PVS_KEYWORD_STATE';


export const CREATE_PVS_KEYWORD_REQUEST = 'pvs/CREATE_PVS_KEYWORD_REQUEST';
export const CREATE_PVS_KEYWORD_SUCCESS = 'pvs/CREATE_PVS_KEYWORD_SUCCESS';
export const CREATE_PVS_KEYWORD_FAILURE = 'pvs/CREATE_PVS_KEYWORD_FAILURE';

export const UPDATE_PVS_KEYWORD_REQUEST = 'pvs/UPDATE_PVS_KEYWORD_REQUEST';
export const UPDATE_PVS_KEYWORD_SUCCESS = 'pvs/UPDATE_PVS_KEYWORD_SUCCESS';
export const UPDATE_PVS_KEYWORD_FAILURE = 'pvs/UPDATE_PVS_KEYWORD_FAILURE';

export const FETCH_PVS_KEYWORD_DETAILS_REQUEST = 'pvs/FETCH_PVS_KEYWORD_DETAILS_REQUEST';
export const FETCH_PVS_KEYWORD_DETAILS_SUCCESS = 'pvs/FETCH_PVS_KEYWORD_DETAILS_SUCCESS';
export const FETCH_PVS_KEYWORD_DETAILS_FAILURE = 'pvs/FETCH_PVS_KEYWORD_DETAILS_FAILURE';

export const FETCH_PVS_BRAND_REQUEST = 'pvs/FETCH_PVS_BRAND_REQUEST';
export const FETCH_PVS_BRAND_SUCCESS = 'pvs/FETCH_PVS_BRAND_SUCCESS';
export const FETCH_PVS_BRAND_FAILURE = 'pvs/FETCH_PVS_BRAND_FAILURE';

export const ALL_BAZAAR_LIST_REQUEST = 'pvs/ALL_BAZAAR_LIST_REQUEST';
export const ALL_BAZAAR_LIST_SUCCESS = 'pvs/ALL_BAZAAR_LIST_SUCCESS';
export const ALL_BAZAAR_LIST_FAILURE = 'pvs/ALL_BAZAAR_LIST_FAILURE';

export const FETCH_STALL_LIST_REQUEST = 'pvs/FETCH_STALL_LIST_REQUEST';
export const FETCH_STALL_LIST_SUCCESS = 'pvs/FETCH_STALL_LIST_SUCCESS';
export const FETCH_STALL_LIST_FAILURE = 'pvs/FETCH_STALL_LIST_FAILURE';
export const FETCH_STALL_LIST_RESET = 'pvs/FETCH_STALL_LIST_RESET';

export const GET_PVS_DETAILS_REQUEST = 'pvs/GET_PVS_DETAILS_REQUEST';
export const GET_PVS_DETAILS_SUCCESS = 'pvs/GET_PVS_DETAILS_SUCCESS';
export const GET_PVS_DETAILS_FAILURE = 'pvs/GET_PVS_DETAILS_FAILURE';
export const GET_PVS_DETAILS_RESET = 'pvs/GET_PVS_DETAILS_RESET';

export const GET_PAYMENT_STATISTICS_REQUEST = 'pvs/GET_PAYMENT_STATISTICS_REQUEST';
export const GET_PAYMENT_STATISTICS_SUCCESS = 'pvs/GET_PAYMENT_STATISTICS_SUCCESS';
export const GET_PAYMENT_STATISTICS_FAILURE = 'pvs/GET_PAYMENT_STATISTICS_FAILURE';
export const GET_PAYMENT_STATISTICS_RESET = 'pvs/GET_PAYMENT_STATISTICS_RESET';

export const FETCH_PVS_DETAILS_REQUEST = 'pvs/FETCH_PVS_DETAILS_REQUEST';
export const FETCH_PVS_DETAILS_SUCCESS = 'pvs/FETCH_PVS_DETAILS_SUCCESS';
export const FETCH_PVS_DETAILS_FAILURE = 'pvs/FETCH_PVS_DETAILS_FAILURE';
export const FETCH_PVS_DETAILS_RESET = 'pvs/FETCH_PVS_DETAILS_RESET';

export const GET_BOOKING_LIST_REQUEST = 'pvs/GET_BOOKING_LIST_REQUEST';
export const GET_BOOKING_LIST_SUCCESS = 'pvs/GET_BOOKING_LIST_SUCCESS';
export const GET_BOOKING_LIST_FAILURE = 'pvs/GET_BOOKING_LIST_FAILURE';
export const GET_BOOKING_LIST_RESET = 'pvs/GET_BOOKING_LIST_RESET';

export const SUBMIT_BOOKING_REQUEST = 'pvs/SUBMIT_BOOKING_REQUEST';
export const SUBMIT_BOOKING_SUCCESS = 'pvs/SUBMIT_BOOKING_SUCCESS';
export const SUBMIT_BOOKING_FAILURE = 'pvs/SUBMIT_BOOKING_FAILURE';
export const SUBMIT_BOOKING_RESET = 'pvs/SUBMIT_BOOKING_RESET';

export const FETCH_BOOKING_DETAILS_REQUEST = 'pvs/FETCH_BOOKING_DETAILS_REQUEST';
export const FETCH_BOOKING_DETAILS_SUCCESS = 'pvs/FETCH_BOOKING_DETAILS_SUCCESS';
export const FETCH_BOOKING_DETAILS_FAILURE = 'pvs/FETCH_BOOKING_DETAILS_FAILURE';
export const FETCH_BOOKING_DETAILS_RESET = 'pvs/FETCH_BOOKING_DETAILS_RESET';

export const ADD_BOOKING_PAYMENT_REQUEST = 'pvs/ADD_BOOKING_PAYMENT_REQUEST';
export const ADD_BOOKING_PAYMENT_SUCCESS = 'pvs/ADD_BOOKING_PAYMENT_SUCCESS';
export const ADD_BOOKING_PAYMENT_FAILURE = 'pvs/ADD_BOOKING_PAYMENT_FAILURE';
export const ADD_BOOKING_PAYMENT_RESET = 'pvs/ADD_BOOKING_PAYMENT_RESET';

export const RESEND_INVOICE_REQUEST = 'pvs/RESEND_INVOICE_REQUEST';
export const RESEND_INVOICE_SUCCESS = 'pvs/RESEND_INVOICE_SUCCESS';
export const RESEND_INVOICE_FAILURE = 'pvs/RESEND_INVOICE_FAILURE';
export const RESEND_INVOICE_RESET = 'pvs/RESEND_INVOICE_RESET';

export const GET_USER_BILLING_INFO_REQUEST = 'pvs/GET_USER_BILLING_INFO_REQUEST';
export const GET_USER_BILLING_INFO_SUCCESS = 'pvs/GET_USER_BILLING_INFO_SUCCESS';
export const GET_USER_BILLING_INFO_FAILURE = 'pvs/GET_USER_BILLING_INFO_FAILURE';
export const GET_USER_BILLING_INFO_RESET = 'pvs/GET_USER_BILLING_INFO_RESET';

export const REGENERATE_INVOICE_REQUEST = 'pvs/REGENERATE_INVOICE_REQUEST';
export const REGENERATE_INVOICE_SUCCESS = 'pvs/REGENERATE_INVOICE_SUCCESS';
export const REGENERATE_INVOICE_FAILURE = 'pvs/REGENERATE_INVOICE_FAILURE';
export const REGENERATE_INVOICE_RESET = 'pvs/REGENERATE_INVOICE_RESET';

export const DOWNLOAD_INVOICES_REQUEST = 'pvs/DOWNLOAD_INVOICES_REQUEST';
export const DOWNLOAD_INVOICES_SUCCESS = 'pvs/DOWNLOAD_INVOICES_SUCCESS';
export const DOWNLOAD_INVOICES_FAILURE = 'pvs/DOWNLOAD_INVOICES_FAILURE';
export const DOWNLOAD_INVOICES_RESET = 'pvs/DOWNLOAD_INVOICES_RESET';

export const DOWNLOAD_BOOKING_REPORT_REQUEST = 'pvs/DOWNLOAD_BOOKING_REPORT_REQUEST';
export const DOWNLOAD_BOOKING_REPORT_SUCCESS = 'pvs/DOWNLOAD_BOOKING_REPORT_SUCCESS';
export const DOWNLOAD_BOOKING_REPORT_FAILURE = 'pvs/DOWNLOAD_BOOKING_REPORT_FAILURE';
export const DOWNLOAD_BOOKING_REPORT_RESET = 'pvs/DOWNLOAD_BOOKING_REPORT_RESET';

export const DOWNLOAD_BAZAAR_INTEREST_LIST_REQUEST = 'pvs/DOWNLOAD_BAZAAR_INTEREST_LIST_REQUEST';
export const DOWNLOAD_BAZAAR_INTEREST_LIST_SUCCESS = 'pvs/DOWNLOAD_BAZAAR_INTEREST_LIST_SUCCESS';
export const DOWNLOAD_BAZAAR_INTEREST_LIST_FAILURE = 'pvs/DOWNLOAD_BAZAAR_INTEREST_LIST_FAILURE';
export const DOWNLOAD_BAZAAR_INTEREST_LIST_RESET = 'pvs/DOWNLOAD_BAZAAR_INTEREST_LIST_RESET';

export const DOWNLOAD_BALANCE_REPORT_REQUEST = 'pvs/DOWNLOAD_BALANCE_REPORT_REQUEST';
export const DOWNLOAD_BALANCE_REPORT_SUCCESS = 'pvs/DOWNLOAD_BALANCE_REPORT_SUCCESS';
export const DOWNLOAD_BALANCE_REPORT_FAILURE = 'pvs/DOWNLOAD_BALANCE_REPORT_FAILURE';
export const DOWNLOAD_BALANCE_REPORT_RESET = 'pvs/DOWNLOAD_BALANCE_REPORT_RESET';

export const GET_BAZAAR_STALL_DETAILS_REQUEST = 'pvs/GET_BAZAAR_STALL_DETAILS_REQUEST';
export const GET_BAZAAR_STALL_DETAILS_SUCCESS = 'pvs/GET_BAZAAR_STALL_DETAILS_SUCCESS';
export const GET_BAZAAR_STALL_DETAILS_FAILURE = 'pvs/GET_BAZAAR_STALL_DETAILS_FAILURE';
export const GET_BAZAAR_STALL_DETAILS_RESET = 'pvs/GET_BAZAAR_STALL_DETAILS_RESET';

export const UPDATE_BAZAAR_STALL_DETAILS_REQUEST = 'pvs/UPDATE_BAZAAR_STALL_DETAILS_REQUEST';
export const UPDATE_BAZAAR_STALL_DETAILS_SUCCESS = 'pvs/UPDATE_BAZAAR_STALL_DETAILS_SUCCESS';
export const UPDATE_BAZAAR_STALL_DETAILS_FAILURE = 'pvs/UPDATE_BAZAAR_STALL_DETAILS_FAILURE';
export const UPDATE_BAZAAR_STALL_DETAILS_RESET = 'pvs/UPDATE_BAZAAR_STALL_DETAILS_RESET';

export const ADD_BAZAAR_STALL_DETAILS_REQUEST = 'pvs/ADD_BAZAAR_STALL_DETAILS_REQUEST';
export const ADD_BAZAAR_STALL_DETAILS_SUCCESS = 'pvs/ADD_BAZAAR_STALL_DETAILS_SUCCESS';
export const ADD_BAZAAR_STALL_DETAILS_FAILURE = 'pvs/ADD_BAZAAR_STALL_DETAILS_FAILURE';
export const ADD_BAZAAR_STALL_DETAILS_RESET = 'pvs/ADD_BAZAAR_STALL_DETAILS_RESET';

export const GET_BAZAAR_DETAILS_REQUEST = 'pvs/GET_BAZAAR_DETAILS_REQUEST';
export const GET_BAZAAR_DETAILS_SUCCESS = 'pvs/GET_BAZAAR_DETAILS_SUCCESS';
export const GET_BAZAAR_DETAILS_FAILURE = 'pvs/GET_BAZAAR_DETAILS_FAILURE';
export const GET_BAZAAR_DETAILS_RESET = 'pvs/GET_BAZAAR_DETAILS_RESET';

export const ADD_BAZAAR_REQUEST = 'pvs/ADD_BAZAAR_REQUEST';
export const ADD_BAZAAR_SUCCESS = 'pvs/ADD_BAZAAR_SUCCESS';
export const ADD_BAZAAR_FAILURE = 'pvs/ADD_BAZAAR_FAILURE';
export const ADD_BAZAAR_RESET = 'pvs/ADD_BAZAAR_RESET';

export const CANCEL_STALL_BOOKING_REQUEST = 'pvs/CANCEL_STALL_BOOKING_REQUEST';
export const CANCEL_STALL_BOOKING_SUCCESS = 'pvs/CANCEL_STALL_BOOKING_SUCCESS';
export const CANCEL_STALL_BOOKING_FAILURE = 'pvs/CANCEL_STALL_BOOKING_FAILURE';
export const CANCEL_STALL_BOOKING_RESET = 'pvs/CANCEL_STALL_BOOKING_RESET';

export const DELETE_AVAILABLE_STALL_REQUEST = 'pvs/DELETE_AVAILABLE_STALL_REQUEST';
export const DELETE_AVAILABLE_STALL_SUCCESS = 'pvs/DELETE_AVAILABLE_STALL_SUCCESS';
export const DELETE_AVAILABLE_STALL_FAILURE = 'pvs/DELETE_AVAILABLE_STALL_FAILURE';
export const DELETE_AVAILABLE_STALL_RESET = 'pvs/DELETE_AVAILABLE_STALL_RESET';

export const GET_BAZAAR_INTEREST_LIST_REQUEST = 'pvs/GET_BAZAAR_INTEREST_LIST_REQUEST';
export const GET_BAZAAR_INTEREST_LIST_SUCCESS = 'pvs/GET_BAZAAR_INTEREST_LIST_SUCCESS';
export const GET_BAZAAR_INTEREST_LIST_FAILURE = 'pvs/GET_BAZAAR_INTEREST_LIST_FAILURE';
export const GET_BAZAAR_INTEREST_LIST_RESET = 'pvs/GET_BAZAAR_INTEREST_LIST_RESET';

export const ADD_BAZAAR_INTEREST_REQUEST = 'pvs/ADD_BAZAAR_INTEREST_REQUEST';
export const ADD_BAZAAR_INTEREST_SUCCESS = 'pvs/ADD_BAZAAR_INTEREST_SUCCESS';
export const ADD_BAZAAR_INTEREST_FAILURE = 'pvs/ADD_BAZAAR_INTEREST_FAILURE';
export const ADD_BAZAAR_INTEREST_RESET = 'pvs/ADD_BAZAAR_INTEREST_RESET';

export const EDIT_BAZAAR_REQUEST = 'pvs/EDIT_BAZAAR_REQUEST';
export const EDIT_BAZAAR_SUCCESS = 'pvs/EDIT_BAZAAR_SUCCESS';
export const EDIT_BAZAAR_FAILURE = 'pvs/EDIT_BAZAAR_FAILURE';
export const EDIT_BAZAAR_RESET = 'pvs/EDIT_BAZAAR_RESET';

export const UPDATE_BAZAAR_ACTIVE_STATUS_REQUEST = 'pvs/UPDATE_BAZAAR_ACTIVE_STATUS_REQUEST';
export const UPDATE_BAZAAR_ACTIVE_STATUS_SUCCESS = 'pvs/UPDATE_BAZAAR_ACTIVE_STATUS_SUCCESS';
export const UPDATE_BAZAAR_ACTIVE_STATUS_FAILURE = 'pvs/UPDATE_BAZAAR_ACTIVE_STATUS_FAILURE';
export const UPDATE_BAZAAR_ACTIVE_STATUS_RESET = 'pvs/UPDATE_BAZAAR_ACTIVE_STATUS_RESET';

export const SUBMIT_BAZAAR_ENQUIRY_REQUEST = 'pvs/SUBMIT_BAZAAR_ENQUIRY_REQUEST';
export const SUBMIT_BAZAAR_ENQUIRY_SUCCESS = 'pvs/SUBMIT_BAZAAR_ENQUIRY_SUCCESS';
export const SUBMIT_BAZAAR_ENQUIRY_FAILURE = 'pvs/SUBMIT_BAZAAR_ENQUIRY_FAILURE';
export const SUBMIT_BAZAAR_ENQUIRY_RESET = 'pvs/SUBMIT_BAZAAR_ENQUIRY_RESET';

export const GET_BAZAAR_ENQUIRY_LIST_REQUEST = 'pvs/GET_BAZAAR_ENQUIRY_LIST_REQUEST';
export const GET_BAZAAR_ENQUIRY_LIST_SUCCESS = 'pvs/GET_BAZAAR_ENQUIRY_LIST_SUCCESS';
export const GET_BAZAAR_ENQUIRY_LIST_FAILURE = 'pvs/GET_BAZAAR_ENQUIRY_LIST_FAILURE';
export const DOWNLOAD_BAZAAR_ENQUIRY_EXCEL_REQUEST = 'pvs/DOWNLOAD_BAZAAR_ENQUIRY_EXCEL_REQUEST';
export const DOWNLOAD_BAZAAR_ENQUIRY_EXCEL_SUCCESS = 'pvs/DOWNLOAD_BAZAAR_ENQUIRY_EXCEL_SUCCESS';
export const DOWNLOAD_BAZAAR_ENQUIRY_EXCEL_FAILURE = 'pvs/DOWNLOAD_BAZAAR_ENQUIRY_EXCEL_FAILURE';
export const DOWNLOAD_BAZAAR_ENQUIRY_EXCEL_RESET = 'pvs/DOWNLOAD_BAZAAR_ENQUIRY_EXCEL_RESET';

export const RESEND_BAZAAR_ENQUIRY_WHATSAPP_REQUEST = 'pvs/RESEND_BAZAAR_ENQUIRY_WHATSAPP_REQUEST';
export const RESEND_BAZAAR_ENQUIRY_WHATSAPP_SUCCESS = 'pvs/RESEND_BAZAAR_ENQUIRY_WHATSAPP_SUCCESS';
export const RESEND_BAZAAR_ENQUIRY_WHATSAPP_FAILURE = 'pvs/RESEND_BAZAAR_ENQUIRY_WHATSAPP_FAILURE';
export const RESEND_BAZAAR_ENQUIRY_WHATSAPP_RESET = 'pvs/RESEND_BAZAAR_ENQUIRY_WHATSAPP_RESET';

export const COMBINE_GROUP_BAZAAR_LIST_REQUEST = 'pvs/COMBINE_GROUP_BAZAAR_LIST_REQUEST';
export const COMBINE_GROUP_BAZAAR_LIST_SUCCESS = 'pvs/COMBINE_GROUP_BAZAAR_LIST_SUCCESS';
export const COMBINE_GROUP_BAZAAR_LIST_FAILURE = 'pvs/COMBINE_GROUP_BAZAAR_LIST_FAILURE';
export const COMBINE_GROUP_BAZAAR_LIST_RESET = 'pvs/COMBINE_GROUP_BAZAAR_LIST_RESET';

export const RESET_PVS_STATE = 'pvs/RESET_PVS_STATE';
export const RESET_PVS_REGISTRATION = 'pvs/RESET_PVS_REGISTRATION';

// Product Types
export const FETCH_PRODUCTS_REQUEST = 'pvs/FETCH_PRODUCTS_REQUEST';
export const FETCH_PRODUCTS_SUCCESS = 'pvs/FETCH_PRODUCTS_SUCCESS';
export const FETCH_PRODUCTS_FAILURE = 'pvs/FETCH_PRODUCTS_FAILURE';
export const FETCH_PRODUCTS_RESET = 'pvs/FETCH_PRODUCTS_RESET';

export const CREATE_PRODUCT_REQUEST = 'pvs/CREATE_PRODUCT_REQUEST';
export const CREATE_PRODUCT_SUCCESS = 'pvs/CREATE_PRODUCT_SUCCESS';
export const CREATE_PRODUCT_FAILURE = 'pvs/CREATE_PRODUCT_FAILURE';
export const CREATE_PRODUCT_RESET = 'pvs/CREATE_PRODUCT_RESET';

export const UPDATE_PRODUCT_REQUEST = 'pvs/UPDATE_PRODUCT_REQUEST';
export const UPDATE_PRODUCT_SUCCESS = 'pvs/UPDATE_PRODUCT_SUCCESS';
export const UPDATE_PRODUCT_FAILURE = 'pvs/UPDATE_PRODUCT_FAILURE';
export const UPDATE_PRODUCT_RESET = 'pvs/UPDATE_PRODUCT_RESET';

export const DELETE_PRODUCT_REQUEST = 'pvs/DELETE_PRODUCT_REQUEST';
export const DELETE_PRODUCT_SUCCESS = 'pvs/DELETE_PRODUCT_SUCCESS';
export const DELETE_PRODUCT_FAILURE = 'pvs/DELETE_PRODUCT_FAILURE';
export const DELETE_PRODUCT_RESET = 'pvs/DELETE_PRODUCT_RESET';

export const FETCH_PRODUCT_DETAILS_REQUEST = 'pvs/FETCH_PRODUCT_DETAILS_REQUEST';
export const FETCH_PRODUCT_DETAILS_SUCCESS = 'pvs/FETCH_PRODUCT_DETAILS_SUCCESS';
export const FETCH_PRODUCT_DETAILS_FAILURE = 'pvs/FETCH_PRODUCT_DETAILS_FAILURE';
export const FETCH_PRODUCT_DETAILS_RESET = 'pvs/FETCH_PRODUCT_DETAILS_RESET';

export const FETCH_ADD_ON_ITEM_LIST_REQUEST = 'pvs/FETCH_ADD_ON_ITEM_LIST_REQUEST';
export const FETCH_ADD_ON_ITEM_LIST_SUCCESS = 'pvs/FETCH_ADD_ON_ITEM_LIST_SUCCESS';
export const FETCH_ADD_ON_ITEM_LIST_FAILURE = 'pvs/FETCH_ADD_ON_ITEM_LIST_FAILURE';
